import React, {useMemo} from 'react';
import {useTable} from 'react-table';
import {Table} from 'semantic-ui-react';


const columnsTable = (setDealerDetail, totals) => [
  {
    'Header': 'TASA DE SERVICIO GENERAL',
    'Footer': () => null,
    'columns': [
      {
        'Header': 'Concesionario',
        'accessor': 'dealerName',
        'Footer': 'TOTAL',
        'Cell': ({row}) => {
          const dealer = row.original.dealerName;
          return (
            <span onClick={() => setDealerDetail(dealer)}>
              {row.original.dealerName}
            </span>
          );
        },
      },
      {
        'Header': 'Líneas de Pedidos',
        'accessor': 'orders',
        'Footer': `${totals?.orders}`,
      },
      {
        'Header': 'Líneas Atendidas',
        'accessor': 'ordersServed',
        'Footer': `${totals?.ordersServed}`,
      },
      {
        'Header': 'Tasa de Servicio',
        'accessor': 'serviceFee',
        'Footer': `${totals?.serviceFee}%`,
        'Cell': ({row}) => `${row.original.serviceFee}%`,
      },
    ],
  },
  {
    'Header': 'PROVEEDORES',
    'Footer': () => null,
    'columns': [
      {
        'Header': 'JPM',
        'accessor': 'jpm',
        'Footer': `${totals?.jpm}`,
      },
      {
        'Header': 'MS',
        'accessor': 'ms',
        'Footer': `${totals?.ms}`,
      },
    ],
  },
];

const GeneralServiceReportTable = ({list, setDealerDetail, totals}) => {
  const generalColumns = columnsTable(setDealerDetail, totals);
  const data = useMemo(() => list, []);
  const columns = useMemo(() => generalColumns, []);

  const {
    getTableProps,
    getTableBodyProps,
    footerGroups,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
    'initialState': {'pageIndex': 0, 'pageSize': 10},
  });

  return (
    <Table className="interactive" compact striped {...getTableProps()}>
      <Table.Header>
        {headerGroups.map((headerGroup) => (
          <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, index) => (
              <Table.HeaderCell
                key={`title-${index}`}
                textAlign="center"
                {...column.getHeaderProps()}
              >
                {column.render('Header')}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
      </Table.Header>
      <Table.Body {...getTableBodyProps()}>
        {!rows.length && (
          <Table.Row>
            <Table.Cell colSpan={12} textAlign="center">
              No hay datos disponibles
            </Table.Cell>
          </Table.Row>
        )}
        {rows.length > 0 &&
          rows.map((row, i) => {
            prepareRow(row);
            return (
              <Table.Row key={i} {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <Table.Cell textAlign="center" {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </Table.Cell>
                  );
                })}
              </Table.Row>
            );
          })}
      </Table.Body>
      <Table.Footer>
        {footerGroups.map((group) => {
          if (group.headers.length > 3) {
            return (<Table.Row {...group.getFooterGroupProps()}>
              {group.headers.map((column) => (
                <Table.Cell textAlign="center" {...column.getFooterProps()}>
                  {column.render('Footer')}
                </Table.Cell>
              ))}
            </Table.Row>);
          }
          return null;
        })}
      </Table.Footer>
    </Table>
  );
};

export default GeneralServiceReportTable;
